import { Component, OnInit, OnDestroy } from '@angular/core';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-active-bonuses',
  templateUrl: './active-bonuses.component.html',
  styleUrls: ['./active-bonuses.component.scss'],
})
export class ActiveBonusesComponent implements OnInit, OnDestroy {
  private bonusArray: any[] = new Array;
  private showTable = false;
  private showNoResults: boolean = false;
  private error = null;

  constructor(
    public events: EventsService,
    private bonusService: BonusService,
    private navigator: Navigator,
    private utils: UtilsService,
    public config: ConfigService,
  ) { }

  ngOnInit() {
    // Subscribe to the bonusForfeit event
    this.events.subscribe('event:bonusForfeit', (data) => {
      this.callGetCustomerCasinoBonusesActive();
    });
  }

  ngOnDestroy() {
    // Unsubscribe from the event
    if (this.events) {
      this.events.unsubscribe('event:bonusForfeit');
    }
  }

  ionViewDidEnter() {
    this.callGetCustomerCasinoBonusesActive();
  }

  private callGetCustomerCasinoBonusesActive() {
    this.bonusService.callGetCustomerCasinoBonusesActive().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.bonusArray = response.payload;
          this.events.publish("event:Totalbonus", { activeBonus: response.payload, page: 'Casino Bonus Active' });

          this.bonusArray.forEach(element => {
            let shortenedDisplayName: string = element.displayName;
            if (shortenedDisplayName.length > 9 && shortenedDisplayName.substr(0, 12).indexOf(" ") == -1) {
              shortenedDisplayName = shortenedDisplayName.substring(0, 7) + "...";
              element.shortenedDisplayName = shortenedDisplayName;
            } else {
              element.shortenedDisplayName = element.displayName;
            }
          });

          if (this.bonusArray.length > 0) {
            this.showTable = true;
            this.showNoResults = false;
          } else {
            this.showTable = false;
            this.showNoResults = true;
          }
        }
      },
      (error) => {
        this.showTable = false;
        this.error = error;
      }
    );
  }

  onTotalBonusClicked(bonus: any) {
    this.events.publish("event:bonusActiveClicked", { activeBonus: bonus });
    this.navigator.navigateTo("BonusDetailsComponent", { multipleModals: true },
      {
        bonus: bonus,
        source: "active",
      }
    );
    return false;
  }

  getBonusAmount(bonus: any): string {
    let bonusAmount: any;
    let currentBonus = parseFloat(bonus.currentBonus) || 0;
    let currentDeposit = parseFloat(bonus.currentDeposit) || 0;
    let currentWinning = parseFloat(bonus.currentWinning) || 0;
    bonusAmount = currentBonus + currentDeposit + currentWinning;
    return bonusAmount.toFixed(2);
  }
}
